
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M6 13h33v7H6zM11 25h11v3H11zM11 31h11v3H11zM24 25h11v3H24zM24 31h11v3H24z","fill":"#D0EFEC"}}),_c('rect',{staticClass:"i-Rectangle 1",attrs:{"width":"34","height":"28","x":"7.5","y":"10.5","stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","rx":".5"}}),_c('path',{staticClass:"i-Line 9",attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M7.5 18.5h34"}}),_c('path',{staticClass:"i-Line 3",attrs:{"stroke":"#234652","stroke-linecap":"square","stroke-linejoin":"round","d":"M13.5 25.5h9"}}),_c('path',{staticClass:"i-Line 10",attrs:{"stroke":"#234652","stroke-linecap":"square","stroke-linejoin":"round","d":"M26.5 25.5h9"}}),_c('path',{staticClass:"i-Line 11",attrs:{"stroke":"#234652","stroke-linecap":"square","stroke-linejoin":"round","d":"M13.5 31.5h9"}}),_c('path',{staticClass:"i-Line 12",attrs:{"stroke":"#234652","stroke-linecap":"square","stroke-linejoin":"round","d":"M26.5 31.5h9"}})])
          )
        }
      }
    